/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;position:relative;height:100%}.smalldisplaybuttongroup[_ngcontent-%COMP%]{margin-top:15px;margin-bottom:15px}.mat-column-SmallDisplay[_ngcontent-%COMP%]{text-align:center}.mat-column-School[_ngcontent-%COMP%]{-webkit-box-flex:2;-ms-flex:2;flex:2}.mat-table[_ngcontent-%COMP%]{margin-top:15px}.error[_ngcontent-%COMP%]{color:red}.actionbar[_ngcontent-%COMP%]{margin-top:15px}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/studentsearch/studentsearch.component.css.shim.ngstyle.js.pre-build-optimizer.js